




























































import { Component, Vue } from 'vue-property-decorator'
import { hasArray, hasOwnProp } from '@/utils'
import { getSession } from '@/service/sessionStorage.service'
import { isNotXPnacl } from '@/service/embedPlayer.service'
import Player from '@/components/Player/index.vue'
import Layout from './helpers/Layout.vue'
import './style.less'

@Component({
  components: {
    Player,
    Layout
  }
})

export default class Streamimg extends Vue {
  constructor () {
    super()

    console.info('📦 [Stream] componentDidMount....')
  }

  // __DATA
  private grid: number = 1
  private columns: any = [1, 4, 6, 7, 9, 10, 12]
  private extension: boolean = isNotXPnacl()
  private relative: any = {}

  // __MOUNTED
  public mounted (): void {
    this.aspectRatio()
    window.addEventListener('resize', this.aspectRatio, false)

    const index: number = (this.columns.indexOf(
      this.columns.filter(
        (h: number) => h <= this.cameras.length
      )
      .slice(-1)[0]
    ) + Number(
        this.columns.indexOf(this.cameras.length) < 0
      )
    )

    this.grid = this.columns[index]
    this.columns = this.columns.slice(0, index + 1)

    // Special KeyCodes.
    window.addEventListener('keydown', this.reExtension, false)
  }

  // __DESTROYED
  public destroyed (): void {
    window.removeEventListener('resize', this.aspectRatio, false)
    window.removeEventListener('keydown', this.reExtension, false)
  }

  // __METHODS
  private aspectRatio (): void {
    let w: number = this.$el.clientWidth
    let h: number = (window.innerHeight - 64)
    let n: number = (h * (16 / 9))
    w = (n < w ? n : w)
    h = (w / (16 / 9))
    this.relative = {
      width : `${Math.round(w)}px`,
      height: `${Math.round(h)}px`
    }
  }

  private reExtension (param: any): void {
    // Shift + Alt + R
    if (param.shiftKey && param.altKey && param.keyCode == 82) {
      window.open('https://www.videoexpertsgroup.com/player_start/')
    }
  }

  // __COMPUTED
  private get view (): any {
    const user: any = this.$store.getters['APP.AUTH/user']
    const id: number = getSession('APP.Streaming')

    if (!hasOwnProp(user, 'permission')) {
      return void 0
    }
    else if (Number(id)) {
      return user.permission.views.find((h: any) => h.id === Number(id))
    }
    else {
      return user.permission.views[0]
    }
  }

  private get cameras (): any {
    if (!hasOwnProp(this.view, 'cameras')) {
      return []
    } else {
      return this.view.cameras
        .remove('isActive', 0)
    }
  }
}
